module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-17.1b1cfefe.svg";